module.exports = __webpack_public_path__ + "6bc2c17/img/more_button.d78b3132.svg";